import { AnalyticsEvent, fireGtmEvent } from 'src/utils/new-analytics';

interface ListingConfirmationBaseContext {
  listingId?: string | null;
}

export const listingConfirmation = {
  prompt: {
    viewed(context: ListingConfirmationBaseContext) {
      fireGtmEvent(AnalyticsEvent.FreeListingContractPageViewed, {
        ...(context.listingId && { listingId: context.listingId }),
      });
    },
  },
  chooseAnotherAdPackage: {
    clicked(context: ListingConfirmationBaseContext) {
      fireGtmEvent(
        AnalyticsEvent.FreeListingContractChooseAnotherAdPackageClicked,
        {
          ...(context.listingId && { listingId: context.listingId }),
        },
      );
    },
  },
  acceptTermsAndConditions: {
    clicked(context: ListingConfirmationBaseContext & { checked: boolean }) {
      fireGtmEvent(
        AnalyticsEvent.FreeListingContractAcceptTermsAndConditionsClicked,
        {
          checked: context.checked,
          ...(context.listingId && { listingId: context.listingId }),
        },
      );
    },
  },
};
